import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../services/axios";

import Select from '../../components/form/Select';
import { DonutChart, PieChart } from '../../components/charts';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"; 
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function EmployeeDashboard() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const [dateRange, setDateRange] = useState([new Date(), null]);
  const [activeCallType, setActiveCallType] = useState("ALL"); 
  const [startDate, endDate] = dateRange;
  const [dateFilter, setDateFilter] = useState("today");
 
  // To-Do List State
  const [todos, setTodos] = useState([]);
  const [newTodo, setNewTodo] = useState("");
    const [open, setOpen] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
  const [newTodoPriority, setNewTodoPriority] = useState("MEDIUM");
  const [callStats, setCallStats] = useState({
    total: 0,
    outgoing: 0,
    missed: 0,
    incoming: 0
  });
  const [callCharts, setCallCharts] = useState({
    labels:[],
    series:[]
  })
  const [newTodoDescription, setNewTodoDescription] = useState("");
  const [newTodoDueDate, setNewTodoDueDate] = useState("");
  const [todoStats, setTodoStats] = useState({
    total: 0,
    pending: 0,
    inProgress: 0,
    completed: 0
  });
  const [todoLoading, setTodoLoading] = useState(false);

  // Call History State for filtered calls
  const [callHistory, setCallHistory] = useState([]);
  useEffect(() => {
    const todayRange = getDateRangeForFilter("today");
    setDateRange(todayRange);
    fetchTodos();
    fetchTodoStats();
  }, []);
  const callhis = async () => {
    try{
      console.log("Fetching call history for date range:", dateRange);
      let get = await axios.get(`/call-collections?limit=10&page=1&startDate=${moment(dateRange[0]).format("YYYY-MM-DD")}&endDate=${moment(dateRange[1]).format("YYYY-MM-DD")}`);
      setCallHistory(get.data.data.data || []);
    }catch(error){
      console.error('Error fetching call history:', error);
      toast.error("Failed to fetch call history");
      setCallHistory([]);
    }
  }
  const callCountStats = async()=>{
      let get = await axios.get(`/call-collections/count/calls?startDate=${moment(dateRange[0]).format("YYYY-MM-DD")}&endDate=${moment(dateRange[1]).format("YYYY-MM-DD")}`);
      // setCallStats(get.data.data.data || {
      //   total: 0,
      //   answered: 0,
      //   missed: 0,
      //   duration: 0
      // });
      if(get.data.data.data){
        setCallStats({
          total: get.data.data.data.OUTGOING+get.data.data.data.INCOMING+get.data.data.data.MISSED+parseInt(get.data.data.data.UNKNOWN || 0) || 0,
          outgoing: get.data.data.data.OUTGOING || 0,
          missed: get.data.data.data.MISSED || 0,
          incoming: get.data.data.data.INCOMING || 0
        })
      }
  }
  const callStatsCharts = async()=>{
    try {
      let get = await axios.get(`/charts/calls?period=custom&startDate=${moment(dateRange[0]).format("YYYY-MM-DD")}&endDate=${moment(dateRange[1]).format("YYYY-MM-DD")}&groupBy=callType`)
      console.log("Chart API Response:", get.data);
      
      if(get.data.data.data){
        if(get.data.data.data.length > 0){
          let label  = []
          let value = []
          get.data.data.data.forEach(item => {
            label.push(item.label);
            value.push(item.value);
          });
          console.log("Chart Data:", { labels: label, series: value });
          setCallCharts({
            labels: label,
            series: value
          });
        } else {
          console.log("No chart data available");
          setCallCharts({
            labels: [],
            series: []
          });
        }
      }
    } catch (error) {
      console.error('Error fetching chart data:', error);
      setCallCharts({
        labels: [],
        series: []
      });
    }
  }
  useEffect(()=>{
    callhis();
    callCountStats();
    callStatsCharts();
  },[dateRange,setDateFilter])
  // Calculate chart data for call status distribution
  const getCallStatusChartData = () => {
    if (!callHistory || callHistory.length === 0) {
      return {
        series: [0],
        labels: ['No Data']
      };
    }

    const statusCounts = callHistory.reduce((acc, call) => {
      const status = call.call_type || 'Unknown';
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});

    return {
      series: Object.values(statusCounts),
      labels: Object.keys(statusCounts)
    };
  };

  // Fallback chart data using call stats
  const getFallbackChartData = () => {
    if (callStats.total === 0) {
      return {
        series: [],
        labels: []
      };
    }

    const data = [];
    const labels = [];
    
    if (callStats.outgoing > 0) {
      data.push(callStats.outgoing);
      labels.push('OUTGOING');
    }
    if (callStats.incoming > 0) {
      data.push(callStats.incoming);
      labels.push('INCOMING');
    }
    if (callStats.missed > 0) {
      data.push(callStats.missed);
      labels.push('MISSED');
    }

    return {
      series: data,
      labels: labels
    };
  };

  const chartData = getCallStatusChartData();
  const fallbackChartData = getFallbackChartData();

  // Fetch todos from API
  const fetchTodos = async () => {
    try {
      setTodoLoading(true);
      const response = await axios.get('/todos/my-todos?page=1&limit=20');
      setTodos(response.data.data.todos || []);
    } catch (error) {
      console.error('Error fetching todos:', error);
    } finally {
      setTodoLoading(false);
    }
  };
  const navigate = useNavigate();
  // Fetch todo statistics
  const fetchTodoStats = async () => {
    try {
      const response = await axios.get('/todos/stats');
      setTodoStats(response.data.data);
    } catch (error) {
      console.error('Error fetching todo stats:', error);
    }
  };
  const getDateRangeForFilter = (filter) => {
    const today = moment();
    switch (filter) {
      case "today":
        return [today.toDate(), today.toDate()];
      case "week":
        const startOfWeek = today.clone().startOf("week");
        const endOfWeek = today.clone().endOf("week");
        return [startOfWeek.toDate(), endOfWeek.toDate()];
      case "custom":
        return dateRange;
      default:
        return [today.toDate(), today.toDate()];
    }
  };
   const handleDateFilterChange = (filter) => {
    setDateFilter(filter);
    if (filter !== 'custom') {
      const newRange = getDateRangeForFilter(filter);
      setDateRange(newRange);
    }
  };
  const getInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
  const userName = user?.name || "User";

  // To-Do List Functions
  const addTodo = async () => {
    if (newTodo.trim()) {
      try {
        setTodoLoading(true);
        const todoData = {
          title: newTodo.trim(),
          description: newTodoDescription.trim(),
          priority: newTodoPriority,
          assignedTo: user.id,
          assigneeType: "employee",
          dueDate: newTodoDueDate ? new Date(newTodoDueDate).toISOString() : null,
          tags: [],
          attachments: []
        };
        
        const response = await axios.post('/todos', todoData);
        await fetchTodos();
        await fetchTodoStats();
        
        // Reset form
        setNewTodo("");
        setNewTodoDescription("");
        setNewTodoDueDate("");
        setNewTodoPriority("MEDIUM");
      } catch (error) {
        console.error('Error creating todo:', error);
      } finally {
        setTodoLoading(false);
      }
    }
  };

  const toggleTodo = async (id) => {
    try {
      const todo = todos.find(t => t.id === id);
      const newStatus = todo.status === 'COMPLETED' ? 'PENDING' : 'COMPLETED';
      
      await axios.put(`/todos/${id}`, { status: newStatus });
      await fetchTodos();
      await fetchTodoStats();
    } catch (error) {
      console.error('Error updating todo:', error);
    }
  };

  const deleteTodo = async (id) => {
    try {
      await axios.delete(`/todos/${id}`);
      await fetchTodos();
      await fetchTodoStats();
    } catch (error) {
      console.error('Error deleting todo:', error);
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "URGENT": return "text-red-600 bg-red-100 border-red-200";
      case "HIGH": return "text-orange-600 bg-orange-100 border-orange-200";
      case "MEDIUM": return "text-yellow-600 bg-yellow-100 border-yellow-200";
      case "LOW": return "text-green-600 bg-green-100 border-green-200";
      default: return "text-gray-600 bg-gray-100 border-gray-200";
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "COMPLETED": return "text-green-600 bg-green-100";
      case "IN_PROGRESS": return "text-blue-600 bg-blue-100";
      case "PENDING": return "text-yellow-600 bg-yellow-100";
      case "CANCELLED": return "text-red-600 bg-red-100";
      default: return "text-gray-600 bg-gray-100";
    }
  };

  // Filter call history based on date filter
  const getFilteredCalls = () => {
    const [filterStart, filterEnd] = dateRange;
    
    if (!filterStart) return callHistory;
    
    const startOfDay = moment(filterStart).startOf('day');
    const endOfDay = filterEnd ? moment(filterEnd).endOf('day') : moment(filterStart).endOf('day');
    
    return callHistory.filter(call => {
      const callDate = moment(call.date);
      return callDate.isBetween(startOfDay, endOfDay, null, '[]');
    });
  };

  const filteredCalls = getFilteredCalls();

  // Get call status color for call history
  const getCallStatusColor = (status) => {
    switch (status) {
      case "INCOMING": return "bg-green-100 text-green-800";
      case "MISSED": return "bg-red-100 text-red-800";
      case "OUTGOING": return "bg-yellow-100 text-yellow-800";
      default: return "bg-gray-100 text-gray-800";
    }
  };

  // Get contact avatar color
  const getAvatarColor = (color) => {
    switch (color) {
      case "blue": return "bg-blue-100 text-blue-600";
      case "purple": return "bg-purple-100 text-purple-600";
      case "red": return "bg-red-100 text-red-600";
      case "green": return "bg-green-100 text-green-600";
      case "yellow": return "bg-yellow-100 text-yellow-600";
      case "indigo": return "bg-indigo-100 text-indigo-600";
      case "pink": return "bg-pink-100 text-pink-600";
      case "cyan": return "bg-cyan-100 text-cyan-600";
      default: return "bg-gray-100 text-gray-600";
    }
  };
 
  const dateFilterOptions = [
    { id: 0, name: "Today", value: "today" },
    { id: 1, name: "This Week", value: "week" },
    { id: 2, name: "Custom Range", value: "custom" },
  ];

  return (
    <>
    <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white py-4 px-6 rounded-lg mb-4">
      <div className="flex items-center justify-between sm:flex-col flex-col md:flex-row">
        <div className="w-full">
          <h2 className="text-2xl font-bold">Hello, {userName}! 👋</h2>
          <p className="text-blue-100 mt-1">
            Welcome back! Here's your call history overview.
          </p>
        </div>
        <div className="text-right w-full">
         <div className='flex justify-end items-center gap-3'>
          {/* Call Type Filter */}
          {/* Date Filter Dropdown */}
          <div className='flex justify-end items-center gap-3'>
            <Select
             className="w-40"
              options={dateFilterOptions.map(option => ({ value: option.value, label: option.name }))}
              value={dateFilter}
              onChange={(selected) => handleDateFilterChange(selected)}
            />
          </div>
          
          {/* Custom Date Picker - Only show when Custom is selected */}
          {dateFilter === 'custom' && (
            <div className='flex justify-end items-center gap-3'>
              <DatePicker
                className='p-3 rounded-lg border text-dark border-gray-300'
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                    setDateRange(update);
                }}
                isClearable={true}
                placeholderText="Select date range"
              />
            </div>
          )}
        </div>
        </div>
      </div>
    </div>
    {/* Stats Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {/* Total Calls */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border-l-4 border-blue-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Calls</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">{callStats.total}</p>
          </div>
          <div className="p-3 bg-blue-100 dark:bg-blue-900/30 rounded-full">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Successful Calls */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border-l-4 border-green-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">OUTGOING</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              {callStats.outgoing}
            </p>
          </div>
          <div className="p-3 bg-green-100 dark:bg-green-900/30 rounded-full">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
        </div>
        
      </div>

      {/* Missed Calls */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border-l-4 border-red-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">MISSED</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">
              {callStats.missed}
            </p>
          </div>
          <div className="p-3 bg-red-100 dark:bg-red-900/30 rounded-full">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
        </div>
      </div>

      {/* Total Tasks */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border-l-4 border-purple-500">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">INCOMMING</p>
            <p className="text-3xl font-bold text-gray-900 dark:text-white">{callStats.incoming}</p>
          </div>
          <div className="p-3 bg-purple-100 dark:bg-purple-900/30 rounded-full">
            {/* Incoming Call Icon */}
            <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 2v6a1 1 0 01-1 1h-6m8-7l-9 9m-2 2a7 7 0 11-9.9 9.9 7 7 0 019.9-9.9z" />
            </svg>
          </div>
        </div>
       
      </div>
    </div>

    

    {/* To-Do List Section */}
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* To-Do List */}
      <div className="lg:col-span-2 bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm flex flex-col h-[500px]">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">My To-Do List</h3>
          <span className="text-md font-bold text-gray-500 dark:text-gray-400">
            {todos.filter(todo => todo.status !== 'COMPLETED').length} / {todos.length} pending
          </span>
        </div>
        
        {/* Add New To-Do - Fixed at top */}
        <div className="mb-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg flex-shrink-0">
          <div className="space-y-3">
            <div className="flex gap-3 flex-wrap md:flex-nowrap">
              <input
                type="text"
                value={newTodo}
                onChange={(e) => setNewTodo(e.target.value)}
                placeholder="Add a new task..."
                className=" w-full sm:w-full md:w-[70%] px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                onKeyPress={(e) => e.key === 'Enter' && !e.shiftKey && addTodo()}
              />
              <select
                value={newTodoPriority}
                onChange={(e) => setNewTodoPriority(e.target.value)}
                className="px-3 w-full sm:w-full md:w-[30%] py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="LOW">Low</option>
                <option value="MEDIUM">Medium</option>
                <option value="HIGH">High</option>
                <option value="URGENT">Urgent</option>
              </select>
            </div>
            <div className="flex gap-3 flex-wrap md:flex-nowrap">
              <input
                type="text"
                value={newTodoDescription}
                onChange={(e) => setNewTodoDescription(e.target.value)}
                placeholder="Description (optional)..."
                className="flex-1 px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="datetime-local"
                value={newTodoDueDate}
                onChange={(e) => setNewTodoDueDate(e.target.value)}
                className="px-3 w-full py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                onClick={addTodo}
                disabled={todoLoading}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
              >
                {todoLoading ? 'Adding...' : 'Add'}
              </button>
            </div>
          </div>
        </div>

        {/* To-Do Items - Scrollable */}
        <div className="flex-1 overflow-y-auto space-y-3 mb-4">
          {todoLoading && todos.length === 0 ? (
            <div className="text-center py-8">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-2"></div>
              <p className="text-gray-500 dark:text-gray-400">Loading tasks...</p>
            </div>
          ) : todos.length === 0 ? (
            <div className="text-center py-8">
              <svg className="w-12 h-12 text-gray-400 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
              </svg>
              <p className="text-gray-500 dark:text-gray-400">No tasks yet. Add your first task above!</p>
            </div>
          ) : (
            todos.map((todo) => (
              <div
                key={todo.id}
                className={`p-4 border rounded-lg transition-all ${
                  todo.status === 'COMPLETED'
                    ? 'bg-gray-50 dark:bg-gray-700 border-gray-200 dark:border-gray-600' 
                    : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 hover:shadow-sm'
                }`}
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-start flex-1">
                    <input
                      type="checkbox"
                      checked={todo.status === 'COMPLETED'}
                      onChange={() => toggleTodo(todo.id)}
                      className="mr-3 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1"
                    />
                    <div className="flex-1">
                      <p className={`font-medium ${
                        todo.status === 'COMPLETED'
                          ? 'line-through text-gray-500 dark:text-gray-400' 
                          : 'text-gray-900 dark:text-white'
                      }`}>
                        {todo.title}
                      </p>
                      {todo.description && (
                        <p className={`text-sm mt-1 ${
                          todo.status === 'COMPLETED'
                            ? 'text-gray-400 dark:text-gray-500' 
                            : 'text-gray-600 dark:text-gray-400'
                        }`}>
                          {todo.description}
                        </p>
                      )}
                      <div className="flex items-center gap-2 mt-2">
                        <span className={`inline-block px-2 py-1 text-xs font-medium rounded-full border ${getPriorityColor(todo.priority)}`}>
                          {todo.priority?.toLowerCase()} priority
                        </span>
                        {todo.status !== 'PENDING' && (
                          <span className={`inline-block px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(todo.status)}`}>
                            {todo.status?.replace('_', ' ').toLowerCase()}
                          </span>
                        )}
                        {todo.dueDate && (
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            Due: {moment(todo.dueDate).format('MMM DD, YYYY HH:mm')}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => deleteTodo(todo.id)}
                    className="ml-3 p-2 text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        {/* To-Do Stats - Fixed at bottom */}
        <div className="pt-4 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
          <div className="flex justify-between items-center text-sm text-gray-600 dark:text-gray-400">
            <span>Total: {todoStats.total} tasks</span>
            <span>Completed: {todoStats.completed}</span>
            <span>Pending: {todoStats.pending}</span>
          </div>
        </div>
      </div>

      {/* Call Status Distribution */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg ">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Call Status</h3>
        
        {/* Pie Chart */}
        <div className="h-48 bg-gray-50 dark:bg-gray-700 rounded-lg mb-4 flex items-center justify-center">
          <div className="text-center w-full pt-[5rem]">
            {(() => {
              // Determine which data to use
              const hasApiData = callCharts.series && callCharts.series.length > 0;
              const hasFallbackData = fallbackChartData.series && fallbackChartData.series.length > 0;
              
              if (hasApiData) {
                return (
                  <PieChart
                    data={callCharts.series}
                    labels={callCharts.labels}
                    height={350}
                    colors={['#3B82F6', '#10B981', '#EF4444', '#8B5CF6']}
                    title="Call Analysis"
                  />
                );
              } else if (hasFallbackData) {
                return (
                  <PieChart
                    data={fallbackChartData.series}
                    labels={fallbackChartData.labels}
                    height={350}
                    colors={['#10B981', '#8B5CF6', '#EF4444']}
                    title="Call Distribution"
                  />
                );
              } else {
                return (
                  <div className="flex flex-col items-center justify-center py-8">
                    <div className="w-24 h-24 rounded-full border-8 border-gray-300 border-t-blue-500 animate-spin mx-auto mb-2"></div>
                    <p className="text-sm text-gray-500">Loading chart data...</p>
                  </div>
                );
              }
            })()}
          </div>
        </div>

     
      </div>
    </div>

    {/* Recent Calls Table */}
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm mt-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
          Recent Calls ({filteredCalls.length})
        </h3>
        <button onClick={(()=>navigate('/employee/calls-history'))} className="text-blue-600 hover:text-blue-700 text-sm font-medium">View All</button>
      </div>
      
      {filteredCalls.length === 0 ? (
        <div className="text-center py-12">
          <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">No calls found</h3>
          <p className="text-gray-600 dark:text-gray-400">No calls match your current filter criteria.</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto">
            <thead>
              <tr className="border-b border-gray-200 dark:border-gray-700">
                <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Contact</th>
                <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Phone</th>
                <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Duration</th>
                <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Status</th>
                <th className="text-left py-3 px-4 font-semibold text-sm text-gray-600 dark:text-gray-400">Time</th>
              </tr>
            </thead>
            <tbody>
              {filteredCalls.map((call) => (
                <tr key={call.id} className="border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50">
                  <td className="py-3 px-4">
                    <div className="flex items-center">
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${getAvatarColor('blue')}`}>
                        <span className="text-sm font-semibold">{getInitials(call.callName)}</span>
                      </div>
                      <span className="font-medium text-gray-900 dark:text-white">{call.callName}</span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-gray-600 dark:text-gray-400">{call.number}</td>
                  <td className="py-3 px-4 text-gray-600 dark:text-gray-400">{ moment.utc(call.callDuration * 1000).format('HH:mm:ss')}</td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-1 text-xs font-semibold rounded-full capitalize ${getCallStatusColor(call.callType)}`}>
                      {call.callType}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-gray-600 dark:text-gray-400">
                    {(() => {
                      // Ensure timestamp is parsed as a number
                      const m = moment(Number(call.callTimeStamp));
                      if (!m.isValid()) return '';
                      if (m.isSame(moment(), 'day')) {
                        return m.fromNow(); // e.g. 'a few minutes ago', 'an hour ago'
                      } else if (m.isSame(moment().subtract(1, 'day'), 'day')) {
                        return 'Yesterday';
                      } else if (m.isAfter(moment().subtract(7, 'days'))) {
                        return m.format('dddd'); // e.g. 'Monday'
                      } else {
                        return m.format('MMM DD, YYYY');
                      }
                    })()}
                  </td>
                
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>

    {/* Quick Access to Call Conversions */}
    {/* <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm mt-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Call Conversions</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">Manage your converted leads and prospects</p>
        </div>
        <div className="flex gap-3">
          <button 
            onClick={() => navigate('/employee/call-conversions')} 
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
          >
            View All Conversions
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-gradient-to-r from-green-500 to-green-600 p-4 rounded-lg text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100">Total Conversions</p>
              <p className="text-2xl font-bold">-</p>
            </div>
            <svg className="w-8 h-8 text-green-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
            </svg>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-4 rounded-lg text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100">This Month</p>
              <p className="text-2xl font-bold">-</p>
            </div>
            <svg className="w-8 h-8 text-blue-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-4 rounded-lg text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-purple-100">Success Rate</p>
              <p className="text-2xl font-bold">-</p>
            </div>
            <svg className="w-8 h-8 text-purple-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
        </div>
      </div>
    </div> */}
    </>
  );
}
